import type { ICompany } from '@/entities/company/model/types';

import { useCompanyApi } from '@/entities/company/api';

import { Types as ModuleTypes } from '@/entities/module';

export const useCompanyStore = defineStore('company', () => {
  const api = useCompanyApi();

  const company = ref<ICompany | null>(null);

  const login = computed(() => company.value?.login || '');

  const fetch = async () => {
    company.value = (await api.fetch()).data;
  };

  const fetchSeo = async (pageId?: string): Promise<{ name: string; value: string }[]> => {
    return (await api.fetchSeo(pageId)).data?.seo ?? [];
  };

  const publish = async () => {
    const { data } = await api.update({ isPublished: true });

    company.value = { ...company.value, ...data };
  };

  const isCoverModuleEnabled = computed(() =>
    company.value?.modules?.find(
      (module) => module.name === ModuleTypes.EModuleNames.COVER && module.isEnabled,
    ),
  );

  return {
    company,
    fetch,
    fetchSeo,
    login,
    publish,
    isCoverModuleEnabled,
  };
});
